// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7730) return "static/chunks/7730-210cf73c139e7774.js";
	if (chunkId === 8139) return "static/chunks/8139-8837ae742a893404.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3179":"3ddc9f734b79f5cf","5560":"422d480b8dee6b13","7573":"e5c1fa2b33d05469","8552":"990624fc146afd8b"}[chunkId] + ".js";
};